import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const { token } = useParams();
  const [message, setMessage] = useState("Verifying email...");
  const [status, setStatus] = useState(null); // 'success' | 'fail' | null
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {
      console.log("[VerifyEmail] Attempting verification with token:", token);
      try {
        const url = `/api/auth/verify-email?token=${token}`;
        console.log("[VerifyEmail] Fetching:", url);
        const res = await fetch(url);
        console.log("[VerifyEmail] Response status:", res.status);
        let data;
        try {
          data = await res.json();
        } catch (jsonErr) {
          console.error("[VerifyEmail] Failed to parse JSON:", jsonErr);
          setStatus('fail');
          setMessage("Verification failed. Invalid server response.");
          return;
        }
        console.log("[VerifyEmail] Response data:", data);
        if (res.ok) {
          setStatus('success');
          setMessage(data.message || '✅ Email verified! You can now log in.');
          setTimeout(() => navigate('/login'), 2000);
        } else {
          setStatus('fail');
          setMessage((data && data.message) ? data.message : 'Verification failed.');
        }
      } catch (err) {
        console.error("[VerifyEmail] Network or fetch error:", err);
        setStatus('fail');
        setMessage("Verification failed. Please try again later.");
      }
    };
    verify();
  }, [token, navigate]);

  return (
    <div className="form-container">
      <h2>Email Verification</h2>
      <p style={{color: status === 'fail' ? '#b30000' : status === 'success' ? '#008000' : undefined}}>
        {message}
      </p>
      {status === 'fail' && (
        <>
          <p style={{color:'#b30000'}}>If you believe this is an error, please try the link again or request a new verification email.</p>
        </>
      )}
    </div>
  );
};

export default VerifyEmail;
